import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithErrorHandling from "../../../api/apiConfig";

export const apiCompanyMissionVisionValueSlice = createApi({
  reducerPath: "CompanyMissionVisionValueApi", // name reducer of API slice
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ["CompanyMissionVisionValue"], // Tag để invalidate cache cho các thao tác như create, update, delete
  endpoints: (builder) => ({
    getListCompanyMissionVisionValue: builder.query({
      query: (params) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/company_mission_vision_value`,
        params: params, // Gửi tham số lên API
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.data.map(({ id }) => ({
                type: "CompanyMissionVisionValue",
                id,
              })),
              { type: "CompanyMissionVisionValue", id: "LIST" },
            ]
          : [{ type: "CompanyMissionVisionValue", id: "LIST" }],
    }),

    createCompanyMissionVisionValue: builder.mutation({
      query: (newCompanyMissionVisionValue) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/company_mission_vision_value`,
        method: "POST",
        body: newCompanyMissionVisionValue,
      }),
      invalidatesTags: (result, error) => {
        return result
          ? [{ type: "CompanyMissionVisionValue", id: "LIST" }]
          : []; // Invalidate cache to refresh data after create
      },
    }),

    updateCompanyMissionVisionValue: builder.mutation({
      query: ({ id, ...updatedCompanyMissionVisionValue }) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/company_mission_vision_value/${id}`,
        method: "PUT", // Có thể dùng PATCH nếu muốn cập nhật một phần dữ liệu
        body: updatedCompanyMissionVisionValue.data,
      }),
      invalidatesTags: (result, error, { id }) =>
        result ? [{ type: "CompanyMissionVisionValue", id }] : [],
    }),

    deleteCompanyMissionVisionValue: builder.mutation({
      query: (id) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/company_mission_vision_value/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error) =>
        result ? [{ type: "CompanyMissionVisionValue", id: "LIST" }] : [],
    }),

    swap: builder.mutation({
      query: (orderSwap) => ({
        url: `/${process.env.REACT_APP_API_VERSION}/company_mission_vision_value/swap`,
        method: "POST",
        body: orderSwap, // Gửi oldIndex và newIndex
      }),
      invalidatesTags: [{ type: "CompanyMissionVisionValue", id: "LIST" }],
    }),
  }),
});

export const {
  useGetListCompanyMissionVisionValueQuery,
  useCreateCompanyMissionVisionValueMutation,
  useUpdateCompanyMissionVisionValueMutation,
  useDeleteCompanyMissionVisionValueMutation,
  useSwapMutation,
} = apiCompanyMissionVisionValueSlice;
